import { render, staticRenderFns } from "./Lk2FA_Auth.vue?vue&type=template&id=77c48348&scoped=true&"
import script from "./Lk2FA_Auth.vue?vue&type=script&lang=js&"
export * from "./Lk2FA_Auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c48348",
  null
  
)

export default component.exports